export const _extName = 'HCAP_holovideo';
export var StreamMode;
(function (StreamMode) {
    StreamMode[StreamMode["Automatic"] = 0] = "Automatic";
    StreamMode[StreamMode["MP4"] = 1] = "MP4";
    StreamMode[StreamMode["HLS"] = 2] = "HLS";
    StreamMode[StreamMode["Dash"] = 3] = "Dash";
})(StreamMode || (StreamMode = {}));
//# sourceMappingURL=holoVideoInterface.js.map